import React from "react";
import { BookOpen, Stack } from "@phosphor-icons/react";
import adaLogo from "@/assets/ada-logo.svg";
import { BACKEND_URL } from "@/lib/constants";
import { cn } from "@/lib/format";
import { NetworkSwitcher } from "@/components/NetworkSwitcher";
import { GovNav } from "@/components/governance/GovNav";

export const Header = ({ onOpenReference, onGoHome, currentView, onGovNavigate, onOpenAssets, govPath }) => (
  <header className="border-b border-primary/20 bg-card/30 backdrop-blur-sm">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3 flex-wrap">
      <button
        data-testid="header-go-home"
        onClick={onGoHome}
        className="flex items-center gap-2.5 group min-w-0"
        title="Back to home"
      >
        <div className="h-9 flex items-center justify-center shrink-0">
          <img src={adaLogo} alt="Ada Explorer logo" data-testid="header-logo" className="h-8 sm:h-9 w-auto object-contain drop-shadow-[0_0_8px_rgba(34,211,238,0.35)]" />
        </div>
        <div className="leading-tight text-left min-w-0">
          <div className="font-heading text-[15px] sm:text-[16px] font-bold tracking-wide text-foreground">Ada Explorer</div>
          <div className="hidden sm:block text-[10px] uppercase tracking-[0.25em] text-muted-foreground mono">
            cardano blockchain explorer
          </div>
        </div>
      </button>
      <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.2em] text-muted-foreground mono flex-wrap">
        <GovNav
          navigate={onGovNavigate}
          govPath={govPath}
          inGovernance={currentView === "governance"}
        />
        <button
          type="button"
          data-testid="header-native-assets"
          onClick={onOpenAssets}
          className={cn(
            "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-colors",
            currentView === "assets-dashboard"
              ? "border-primary/50 bg-primary/15 text-primary"
              : "border-transparent hover:text-foreground hover:bg-muted/30",
          )}
        >
          <Stack size={13} weight={currentView === "assets-dashboard" ? "fill" : "regular"} /> native assets
        </button>
        <NetworkSwitcher />
        <button
          data-testid="open-api-reference"
          onClick={onOpenReference}
          className="inline-flex items-center gap-1.5 border border-primary/50 bg-primary/10 text-primary px-3 py-1.5 hover:bg-primary/20 transition-colors rounded-lg"
        >
          <BookOpen size={12} /> API reference
        </button>
        <a
          href={`${BACKEND_URL}/api/docs`}
          target="_blank"
          rel="noreferrer"
          data-testid="header-docs-link"
          className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors"
        >
          swagger
        </a>
      </div>
    </div>
  </header>
);
